import get from 'object-get';
import i18next from 'i18next';
import fallbackTranslations from '../assets/locales/translation.zu.json';

// FIXME: fallback translations doesn't work with var substitution
export const t = (key: string, data?: Record<string, unknown>): string => {
  const fullKey = `app-shell:${key}`;
  const translated = i18next.t(fullKey, data);
  if (translated && translated !== fullKey) return translated;

  const fallback = get(fallbackTranslations, key);
  return typeof fallback === 'string' ? fallback : '';
};
